import { apiFactory } from '../ApiFactory';

export type CreateMemberDto = {
	name: string;
	email: string;
	phone: string;
};

type AccessTokenResponse = { id: number; access_token: string };

const create = async (data: CreateMemberDto) => {
	const client = await apiFactory.getInstance().getCurseducaProfClient();

	return client.post<AccessTokenResponse>('/user', data);
};

const getAccessTokenByEmail = async (email: string) => {
	const client = await apiFactory.getInstance().getCurseducaProfClient();

	return client.get<AccessTokenResponse>('/user-access-token', {
		params: { email }
	});
};

export const membersApi = {
	create,
	getAccessTokenByEmail
};
